import React, { useState, useEffect } from "react";
import style from "./App.css";
const Search = (props) => {
  const [searchText, setSearchText] = useState("");
  const handleChange = (e) => {
    setSearchText(e.target.value);
  };
  useEffect(() => {
    props.onSearch(searchText);
  }, [searchText]);
  return (
    <div style={{ textAlign: "center" }}>
      <input
        type="text"
        placeholder="Search Country"
        value={searchText}
        onChange={handleChange}
        style={{
          backgroundColor: "bisque",
          width: "20rem",
          borderRadius: "0.6rem",
          padding: "0.6rem",
        }}
      />
    </div>
  );
};

export default Search;
